import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Accreditation } from '../types'

export const useAccreditationStore = defineStore('accreditationStore', () => {
  /////////////////////////////////////////////////////////////////////////////
  // State
  /////////////////////////////////////////////////////////////////////////////

  const screeningAccreditation = ref<Accreditation>(null)

  /////////////////////////////////////////////////////////////////////////////
  // Actions
  /////////////////////////////////////////////////////////////////////////////

  const updateResponse = async (accreditationId: string, payload: { response: any }, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/screening/accreditations/${accreditationId}/update-response`).post(payload)
  }

  const getAccreditation = async (accreditationId: string, { slug }: { slug: string }) => {
    const data = await useFetch(`/v4/${slug}/screening/accreditations/${accreditationId}`).get<Accreditation>()

    screeningAccreditation.value = data
  }

  /////////////////////////////////////////////////////////////////////////////

  return {
    updateResponse,
    getAccreditation,
    screeningAccreditation,
  }
})
